import axios from 'axios';

const API_URL = `https://gnews.io/api/v3/search?q=bitcoin&token=${process.env.REACT_APP_API_KEY}`

//async function grabbing bitCoin data
export const getNews = async () => {
  const result = await axios.get(API_URL)
  .then(response => {
  console.log(response.data);
  return response.data.articles;
  });
  return(result);
}

// old call from newsapi - broken key
// const API_URL = "https://newsapi.org/v2/everything?q=bitcoin&from=2020-5-27&sortBy=publishedAt&apiKey=1b823477c9864b7ebb4eb4e9d4148238";
// const API_URL = `https://newsapi.org/v2/everything?q=bitcoin&from=2020-5-27&sortBy=publishedAt&apiKey=${process.env.REACT_APP_API_KEY}`
